window.addEvent('domready', function () {
    // Add IE class
    if (Browser.ie) {
        document.id(document.body).addClass('ie');
    }

    // Add GA tracking attributes
    $$(document.links).filter(function (a) {
        if (a.href.test('.pdf$', 'i')) {
            a.set({
                'ga-on': 'click',
                'ga-event-category': 'Download',
                'ga-event-action': 'click',
                'ga-event-label': a.href
            });
        }
    });

    // Barometer
    $$('#container .barometer .content').each(function (element) {
        var barometer = new Barometer(element, {
            ga_tracker: window.pageTracker,
            ga_actions_delay: {
                show: 2000
            }
        });

        // Get custom tracking category
        var name = element.getElement('h2'),
            period = element.getElement('p');
        if (name) {
            barometer.options.ga_category = name.get('text');
            if (period) {
                barometer.options.ga_category += ' ' + period.get('text');
            }
        }
    });

    // Open external links in new window
    $$(document.links).filter(function (a) {
        return !a.getProperty('target') && // Already has a target attribute
            (a.href.test('^http', 'i') && !a.href.test('^' + document.location.href.substring(0, document.location.href.indexOf('/', 8)), 'i')) || // Different domain name
            a.href.test('.pdf$', 'i') || // PDF extension
            (a.getProperty('rel') && a.getProperty('rel').contains('external', ' ')); // External link
    }).setProperty('target', '_blank');
});